<template>
  <div style="position: relative;">
    <BLoading :active.sync="isLoading" :is-full-page="false" />
    <h4 v-if="!priced" class="ls-typical-pricing--unpriced">
      Price TBD
      <h4 v-if="low_price && high_price">
        (typically between
        <h4 class="has-text-weight-bold">
          {{ low_price | currency }} - {{ high_price | currency }}
        </h4>
        in your area)
      </h4>
    </h4>
    <span v-else-if="low_price && high_price">
      This service in your area is typically priced between
      <span class="has-text-weight-bold">
        {{ low_price | currency }} - {{ high_price | currency }}
      </span>
    </span>
  </div>
</template>

<script>
import VueTypes from 'vue-types';
import { mapActions } from 'vuex';
import { PROPERTIES__GET_SERVICE_PRICING } from '@/store/types';
import _ from 'lodash';

export default {
  name: 'LsTypicalPricing',
  props: {
    propertyId: VueTypes.oneOfType([String, Number]),
    marketId: VueTypes.oneOfType([String, Number]),
    serviceId: VueTypes.oneOfType([String, Number]).isRequired,
    priced: VueTypes.bool.def(false),
  },
  data() {
    return {
      isLoading: true,
      low_price: null,
      high_price: null,
    };
  },
  created() {
    this[PROPERTIES__GET_SERVICE_PRICING]({
      property_id: this.propertyId,
      market_id: this.marketId,
      service_id: this.serviceId,
    }).then((data) => {
      this.low_price = _.get(data, 'low_price');
      this.high_price = _.get(data, 'high_price');
      this.isLoading = false;
    });
  },
  methods: {
    ...mapActions([PROPERTIES__GET_SERVICE_PRICING]),
  },
};
</script>

<style lang="scss" scoped>
.ls-typical-pricing--unpriced {
  h4 {
    display: inline;
  }
}
</style>
